<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 50px">
        <el-date-picker v-fixZoom
          :clearable="false"
          v-model="logDate"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px; width: 400px">
        </el-date-picker>
        <el-button type="primary" @click="getLogData()">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto;">
        <el-table
          :data="showTable"
          border
          style="width: 100%;margin-top: 10px"
          highlight-current-row
          ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center">
          </el-table-column>
          <el-table-column
            label="登录账号"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              {{userName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="time"
            label="登录时间"
            min-width="140"
            align="center">
          </el-table-column>
          <el-table-column
            label="日志类型"
            min-width="85"
            align="center">
            <template slot-scope="scope">
              {{logTypeName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
            label="IP"
            min-width="85"
            align="center">
            <template slot-scope="scope">
              {{numberToIp(scope.row.ip)}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {queryloginlog} from '../../api/log'
import {queryuser} from '../../api/account'

export default {
  name: 'loginLog',
  data () {
    return {
      logDate: [],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      users: []
    }
  },
  created () {
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd')
    this.logDate = [date, date]
    this.getAccountTable()
  },
  mounted () {
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      // console.log(endDate)
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            // console.log(end, start)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      // console.log(arrTime)
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions2.shortcuts = arrTime
    },
    // 登录账号
    getAccountTable () {
      queryuser().then(res => {
        this.users = res.data.users
        this.getLogData()
      }).catch(() => {})
    },
    getLogData () {
      let data = {
        from: this.logDate[0] + ' 00:00:00',
        to: this.logDate[1] + ' 23:59:59'
      }
      queryloginlog(data).then(res => {
        this.tableData = res.data.loginlog
        this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        this.totalCells = this.tableData.length
      }).catch(() => {})
    },
    userName (row) {
      for (let i = 0; i < this.users.length; i++) {
        if (row.userid === this.users[i].id) {
          return this.users[i].username
        }
      }
    },
    logTypeName (row) {
      return this.commonType.getLogType(row.logtype)
    },
    numberToIp (number) {
      let ip = ''
      if (number <= 0) {
        return ip
      }
      const ip3 = (number << 0) >>> 24
      const ip2 = (number << 8) >>> 24
      const ip1 = (number << 16) >>> 24
      const ip0 = (number << 24) >>> 24
      ip += ip3 + '.' + ip2 + '.' + ip1 + '.' + ip0
      return ip
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemlog/loginLog.vue